import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
class ModalWarning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.closeAddModal = this.closeAddModal.bind(this);
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  closeAddModal = (e) => {
    e.preventDefault();
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onClose();
    }, 400);
  };
  render() {
    const { t } = this.props;
    return (
      <StyleRoot>
        <div
          class="modal fade show modal-skin"
          id="modalWarning"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <form>
                <button
                  type="button"
                  onClick={this.closeAddModal}
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div class="modal-body">
                  <section>
                    <h5 class="modal-title">{t('events.edit_event')}</h5>
                  </section>
                  <section>
                    <h5>
                      {t('validation.cannot_edit_past_cancelled')}
                    </h5>
                  </section>
                  <p class="bottom-space"></p>
                  <div class="d-flex justify-content-center">
                    <button
                      onClick={this.closeAddModal}
                      class="btn-gradient btn-valid"
                      data-dismiss="modal"
                    >
                      {t('common.ok')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

export default withTranslation()(ModalWarning);
